import { AppSettings } from './../constants/contants';
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Observable, throwError } from 'rxjs'
import { DeviceDetectorService } from 'ngx-device-detector';


@Injectable({
  providedIn: 'root'
})
export class AppdataService {

  deviceInfo = null;
  ipAddress: any;

  constructor(private http: Http, private deviceService: DeviceDetectorService) {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.fnGetIpAddress();
    //console.log(this.deviceInfo)
  }


  fnpostInputParams(url, params) {
    const headers = new Headers({
      //'Content-Type': "application/x-www-form-urlencoded",
     //'Content-Type': "application/JSON",
     //'token': '',
      'authkey': (sessionStorage.authkey === undefined) ? 1 : JSON.parse(sessionStorage.authkey),
    });
    return this.http.post(url, params, { headers: headers });
  }

  
  fngetInputParams(url, params) {
    const headers = new Headers({
      //'Content-Type': "application/x-www-form-urlencoded",
      'Content-Type': "application/JSON",
      'token': '',
      'authkey': (sessionStorage.authkey === undefined) ? 1 : JSON.parse(sessionStorage.authkey),
    });
    return this.http.get(url, { headers: headers });
  }




  //Company
  fnInsertCompany(params) {

    return this.fnpostInputParams(AppSettings.insertCompanyUrl, params);
  }

  fnSetCompany(params) {

    return this.fnpostInputParams(AppSettings.setCompanyUrl, params);
  }


  getCompany(params) {

    return this.fnpostInputParams(AppSettings.getCompanyUrl, params);
  }


  fnDeleteCompany(params) {

    return this.fnpostInputParams(AppSettings.deleteCompanyUrl, params);
  }

  fnCheckCompany(params) {

    return this.fnpostInputParams(AppSettings.checkCompanyUrl, params);
  }
  getCompanyCheckDetails(params) {
    return this.fnpostInputParams(AppSettings.getcompanycheckdetailsUrl, params);
  }
  fnInsertCompanyRegistration(params) {
    return this.fnpostInputParams(AppSettings.insertCompanyRegistrationUrl, params);
  }
  


  //Branch
  fnInsertBranch(params) {

    return this.fnpostInputParams(AppSettings.insertBranchUrl, params);
  }

  fnSetBranch(params) {

    return this.fnpostInputParams(AppSettings.setBranchUrl, params);
  }


  getBranch(params) {

    return this.fnpostInputParams(AppSettings.getBranchUrl, params);
  }


  fnDeleteBranch(params) {

    return this.fnpostInputParams(AppSettings.deleteBranchUrl, params);
  }

  fnCheckBranch(params) {

    return this.fnpostInputParams(AppSettings.checkBranchUrl, params);
  }



  //Allowance
  fnInsertAllowance(params) {

    return this.fnpostInputParams(AppSettings.insertAllowanceUrl, params);
  }

  fnSetAllowance(params) {

    return this.fnpostInputParams(AppSettings.setAllowanceUrl, params);
  }


  getAllowance(params) {

    return this.fnpostInputParams(AppSettings.getAllowanceUrl, params);
  }


  fnDeleteAllowance(params) {

    return this.fnpostInputParams(AppSettings.deleteAllowanceUrl, params);
  }

  fnCheckAllowance(params) {

    return this.fnpostInputParams(AppSettings.checkAllowanceUrl, params);
  }


  //AssetType
  fnInsertAssetType(params) {

    return this.fnpostInputParams(AppSettings.insertAssetTypeUrl, params);
  }

  fnSetAssetType(params) {

    return this.fnpostInputParams(AppSettings.setAssetTypeUrl, params);
  }


  getAssetType(params) {

    return this.fnpostInputParams(AppSettings.getAssetTypeUrl, params);
  }


  fnDeleteAssetType(params) {

    return this.fnpostInputParams(AppSettings.deleteAssetTypeUrl, params);
  }

  fnCheckAssetType(params) {

    return this.fnpostInputParams(AppSettings.checkAssetTypeUrl, params);
  }


  //BonusType
  fnInsertBonusType(params) {

    return this.fnpostInputParams(AppSettings.insertBonusTypeUrl, params);
  }

  fnSetBonusType(params) {

    return this.fnpostInputParams(AppSettings.setBonusTypeUrl, params);
  }


  getBonusType(params) {

    return this.fnpostInputParams(AppSettings.getBonusTypeUrl, params);
  }


  fnDeleteBonusType(params) {

    return this.fnpostInputParams(AppSettings.deleteBonusTypeUrl, params);
  }

  fnCheckBonusType(params) {

    return this.fnpostInputParams(AppSettings.checkBonusTypeUrl, params);
  }


  //Department
  fnInsertDepartment(params) {

    return this.fnpostInputParams(AppSettings.insertDepartmentUrl, params);
  }

  fnSetDepartment(params) {

    return this.fnpostInputParams(AppSettings.setDepartmentUrl, params);
  }


  getDepartment(params) {

    return this.fnpostInputParams(AppSettings.getDepartmentUrl, params);
  }


  fnDeleteDepartment(params) {

    return this.fnpostInputParams(AppSettings.deleteDepartmentUrl, params);
  }

  fnCheckDepartment(params) {

    return this.fnpostInputParams(AppSettings.checkDepartmentUrl, params);
  }


  //Deduction
  fnInsertDeduction(params) {

    return this.fnpostInputParams(AppSettings.insertDeductionUrl, params);
  }

  fnSetDeduction(params) {

    return this.fnpostInputParams(AppSettings.setDeductionUrl, params);
  }


  getDeduction(params) {

    return this.fnpostInputParams(AppSettings.getDeductionUrl, params);
  }


  fnDeleteDeduction(params) {

    return this.fnpostInputParams(AppSettings.deleteDeductionUrl, params);
  }

  fnCheckDeduction(params) {

    return this.fnpostInputParams(AppSettings.checkDeductionUrl, params);
  }



  //Designation
  fnInsertDesignation(params) {

    return this.fnpostInputParams(AppSettings.insertDesignationUrl, params);
  }

  fnSetDesignation(params) {

    return this.fnpostInputParams(AppSettings.setDesignationUrl, params);
  }


  getDesignation(params) {

    return this.fnpostInputParams(AppSettings.getDesignationUrl, params);
  }

  getDesignationCompany(params) {

    return this.fngetInputParams(AppSettings.getDesignationCompanyUrl,params);
  }



  fnDeleteDesignation(params) {

    return this.fnpostInputParams(AppSettings.deleteDesignationUrl, params);
  }

  fnCheckDesignation(params) {

    return this.fnpostInputParams(AppSettings.checkDesignationUrl, params);
  }

 //Country
 getCountries() {
  const headers = new Headers({
     'Content-Type': "application/JSON",
     'X-CSCAPI-KEY': "cmZXSktRU2h5QWpYa1JnZVhYSldmUmhFc1pDZEZ2WDV5ZzVYMkQzRA=="
     // 'token': (sessionStorage.rbookadtoken === undefined) ? '' : JSON.parse(sessionStorage.rbookadtoken)                
  });


  return this.http.get("https://api.countrystatecity.in/v1/countries", { headers: headers });

}
getState(country) {
  const headers = new Headers({
     'Content-Type': "application/JSON",
     'X-CSCAPI-KEY': "cmZXSktRU2h5QWpYa1JnZVhYSldmUmhFc1pDZEZ2WDV5ZzVYMkQzRA=="
     // 'token': (sessionStorage.rbookadtoken === undefined) ? '' : JSON.parse(sessionStorage.rbookadtoken)                
  });


  return this.http.get("https://api.countrystatecity.in/v1/countries/" + country + "/states", { headers: headers });

}

  //EmpType
  fnInsertEmpType(params) {

    return this.fnpostInputParams(AppSettings.insertEmpTypeUrl, params);
  }

  fnSetEmpType(params) {

    return this.fnpostInputParams(AppSettings.setEmpTypeUrl, params);
  }


  getEmpType(params) {

    return this.fnpostInputParams(AppSettings.getEmpTypeUrl, params);
  }


  fnDeleteEmpType(params) {

    return this.fnpostInputParams(AppSettings.deleteEmpTypeUrl, params);
  }

  fnCheckEmpType(params) {

    return this.fnpostInputParams(AppSettings.checkEmpTypeUrl, params);
  }









  //ExpenseType
  fnInsertExpenseType(params) {

    return this.fnpostInputParams(AppSettings.insertExpenseTypeUrl, params);
  }

  fnSetExpenseType(params) {

    return this.fnpostInputParams(AppSettings.setExpenseTypeUrl, params);
  }


  getExpenseType(params) {

    return this.fnpostInputParams(AppSettings.getExpenseTypeUrl, params);
  }


  fnDeleteExpenseType(params) {

    return this.fnpostInputParams(AppSettings.deleteExpenseTypeUrl, params);
  }

  fnCheckExpenseType(params) {

    return this.fnpostInputParams(AppSettings.checkExpenseTypeUrl, params);
  }



  //Gender
  fnInsertGender(params) {

    return this.fnpostInputParams(AppSettings.insertGenderUrl, params);
  }

  fnSetGender(params) {

    return this.fnpostInputParams(AppSettings.setGenderUrl, params);
  }


  getGender(params) {

    return this.fnpostInputParams(AppSettings.getGenderUrl, params);
  }


  fnDeleteGender(params) {

    return this.fnpostInputParams(AppSettings.deleteGenderUrl, params);
  }

  fnCheckGender(params) {

    return this.fnpostInputParams(AppSettings.checkGenderUrl, params);
  }




  //Grade
  fnInsertGrade(params) {

    return this.fnpostInputParams(AppSettings.insertGradeUrl, params);
  }

  fnSetGrade(params) {

    return this.fnpostInputParams(AppSettings.setGradeUrl, params);
  }


  getGrade(params) {

    return this.fnpostInputParams(AppSettings.getGradeUrl, params);
  }


  fnDeleteGrade(params) {

    return this.fnpostInputParams(AppSettings.deleteGradeUrl, params);
  }

  fnCheckGrade(params) {

    return this.fnpostInputParams(AppSettings.checkGradeUrl, params);
  }



  //IncidentType
  fnInsertIncidentType(params) {

    return this.fnpostInputParams(AppSettings.insertIncidentTypeUrl, params);
  }

  fnSetIncidentType(params) {

    return this.fnpostInputParams(AppSettings.setIncidentTypeUrl, params);
  }


  getIncidentType(params) {

    return this.fnpostInputParams(AppSettings.getIncidentTypeUrl, params);
  }


  fnDeleteIncidentType(params) {

    return this.fnpostInputParams(AppSettings.deleteIncidentTypeUrl, params);
  }

  fnCheckIncidentType(params) {

    return this.fnpostInputParams(AppSettings.checkIncidentTypeUrl, params);
  }




  //LeaveType
  fnInsertLeaveType(params) {

    return this.fnpostInputParams(AppSettings.insertLeaveTypeUrl, params);
  }

  fnSetLeaveType(params) {

    return this.fnpostInputParams(AppSettings.setLeaveTypeUrl, params);
  }


  getLeaveType(params) {

    return this.fnpostInputParams(AppSettings.getLeaveTypeUrl, params);
  }


  getLeaveTypeByEmpid(params) {

    return this.fnpostInputParams(AppSettings.getLeaveTypeByEmpidUrl, params);
  }



  fnDeleteLeaveType(params) {

    return this.fnpostInputParams(AppSettings.deleteLeaveTypeUrl, params);
  }

  fnCheckLeaveType(params) {

    return this.fnpostInputParams(AppSettings.checkLeaveTypeUrl, params);
  }




  //LoanType
  fnInsertLoanType(params) {

    return this.fnpostInputParams(AppSettings.insertLoanTypeUrl, params);
  }

  fnSetLoanType(params) {

    return this.fnpostInputParams(AppSettings.setLoanTypeUrl, params);
  }


  getLoanType(params) {

    return this.fnpostInputParams(AppSettings.getLoanTypeUrl, params);
  }


  fnDeleteLoanType(params) {

    return this.fnpostInputParams(AppSettings.deleteLoanTypeUrl, params);
  }

  fnCheckLoanType(params) {

    return this.fnpostInputParams(AppSettings.checkLoanTypeUrl, params);
  }




  //Location
  fnInsertLocation(params) {

    return this.fnpostInputParams(AppSettings.insertLocationUrl, params);
  }

  fnSetLocation(params) {

    return this.fnpostInputParams(AppSettings.setLocationUrl, params);
  }


  getLocation(params) {

    return this.fnpostInputParams(AppSettings.getLocationUrl, params);
  }


  fnDeleteLocation(params) {

    return this.fnpostInputParams(AppSettings.deleteLocationUrl, params);
  }

  fnCheckLocation(params) {

    return this.fnpostInputParams(AppSettings.checkLocationUrl, params);
  }





  //MaritalStatus
  fnInsertMaritalStatus(params) {

    return this.fnpostInputParams(AppSettings.insertMaritalStatusUrl, params);
  }

  fnSetMaritalStatus(params) {

    return this.fnpostInputParams(AppSettings.setMaritalStatusUrl, params);
  }


  getMaritalStatus(params) {

    return this.fnpostInputParams(AppSettings.getMaritalStatusUrl, params);
  }


  fnDeleteMaritalStatus(params) {

    return this.fnpostInputParams(AppSettings.deleteMaritalStatusUrl, params);
  }

  fnCheckMaritalStatus(params) {

    return this.fnpostInputParams(AppSettings.checkMaritalStatusUrl, params);
  }




  //MemoType
  fnInsertMemoType(params) {

    return this.fnpostInputParams(AppSettings.insertMemoTypeUrl, params);
  }

  fnSetMemoType(params) {

    return this.fnpostInputParams(AppSettings.setMemoTypeUrl, params);
  }


  getMemoType(params) {

    return this.fnpostInputParams(AppSettings.getMemoTypeUrl, params);
  }


  fnDeleteMemoType(params) {

    return this.fnpostInputParams(AppSettings.deleteMemoTypeUrl, params);
  }

  fnCheckMemoType(params) {

    return this.fnpostInputParams(AppSettings.checkMemoTypeUrl, params);
  }




  //OverTimeType
  fnInsertOverTimeType(params) {

    return this.fnpostInputParams(AppSettings.insertOverTimeTypeUrl, params);
  }

  fnSetOverTimeType(params) {

    return this.fnpostInputParams(AppSettings.setOverTimeTypeUrl, params);
  }


  getOverTimeType(params) {

    return this.fnpostInputParams(AppSettings.getOverTimeTypeUrl, params);
  }


  fnDeleteOverTimeType(params) {

    return this.fnpostInputParams(AppSettings.deleteOverTimeTypeUrl, params);
  }

  fnCheckOverTimeType(params) {

    return this.fnpostInputParams(AppSettings.checkOverTimeTypeUrl, params);
  }




  //PayMode
  fnInsertPayMode(params) {

    return this.fnpostInputParams(AppSettings.insertPayModeUrl, params);
  }

  fnSetPayMode(params) {

    return this.fnpostInputParams(AppSettings.setPayModeUrl, params);
  }


  getPayMode(params) {

    return this.fnpostInputParams(AppSettings.getPayModeUrl, params);
  }


  fnDeletePayMode(params) {

    return this.fnpostInputParams(AppSettings.deletePayModeUrl, params);
  }

  fnCheckPayMode(params) {

    return this.fnpostInputParams(AppSettings.checkPayModeUrl, params);
  }




  //Payrollgrp
  fnInsertPayrollgrp(params) {

    return this.fnpostInputParams(AppSettings.insertPayrollgrpUrl, params);
  }

  fnSetPayrollgrp(params) {

    return this.fnpostInputParams(AppSettings.setPayrollgrpUrl, params);
  }


  getPayrollgrp(params) {

    return this.fnpostInputParams(AppSettings.getPayrollgrpUrl, params);
  }


  fnDeletePayrollgrp(params) {

    return this.fnpostInputParams(AppSettings.deletePayrollgrpUrl, params);
  }

  fnCheckPayrollgrp(params) {

    return this.fnpostInputParams(AppSettings.checkPayrollgrpUrl, params);
  }





  //ReimburseType
  fnInsertReimburseType(params) {

    return this.fnpostInputParams(AppSettings.insertReimburseTypeUrl, params);
  }

  fnSetReimburseType(params) {

    return this.fnpostInputParams(AppSettings.setReimburseTypeUrl, params);
  }


  getReimburseType(params) {

    return this.fnpostInputParams(AppSettings.getReimburseTypeUrl, params);
  }


  fnDeleteReimburseType(params) {

    return this.fnpostInputParams(AppSettings.deleteReimburseTypeUrl, params);
  }

  fnCheckReimburseType(params) {

    return this.fnpostInputParams(AppSettings.checkReimburseTypeUrl, params);
  }





  //Relationship
  fnInsertRelationship(params) {

    return this.fnpostInputParams(AppSettings.insertRelationshipUrl, params);
  }

  fnSetRelationship(params) {

    return this.fnpostInputParams(AppSettings.setRelationshipUrl, params);
  }


  getRelationship(params) {

    return this.fnpostInputParams(AppSettings.getRelationshipUrl, params);
  }


  fnDeleteRelationship(params) {

    return this.fnpostInputParams(AppSettings.deleteRelationshipUrl, params);
  }

  fnCheckRelationship(params) {

    return this.fnpostInputParams(AppSettings.checkRelationshipUrl, params);
  }




  //RelieveType
  fnInsertRelieveType(params) {

    return this.fnpostInputParams(AppSettings.insertRelieveTypeUrl, params);
  }

  fnSetRelieveType(params) {

    return this.fnpostInputParams(AppSettings.setRelieveTypeUrl, params);
  }


  getRelieveType(params) {

    return this.fnpostInputParams(AppSettings.getRelieveTypeUrl, params);
  }


  fnDeleteRelieveType(params) {

    return this.fnpostInputParams(AppSettings.deleteRelieveTypeUrl, params);
  }

  fnCheckRelieveType(params) {

    return this.fnpostInputParams(AppSettings.checkRelieveTypeUrl, params);
  }




  //Skills
  fnInsertSkills(params) {

    return this.fnpostInputParams(AppSettings.insertSkillsUrl, params);
  }

  fnSetSkills(params) {

    return this.fnpostInputParams(AppSettings.setSkillsUrl, params);
  }


  getSkills(params) {

    return this.fnpostInputParams(AppSettings.getSkillsUrl, params);
  }


  fnDeleteSkills(params) {

    return this.fnpostInputParams(AppSettings.deleteSkillsUrl, params);
  }

  fnCheckSkills(params) {

    return this.fnpostInputParams(AppSettings.checkSkillsUrl, params);
  }



  //UserRole
  fnInsertUserRole(params) {

    return this.fnpostInputParams(AppSettings.insertUserRoleUrl, params);
  }

  fnSetUserRole(params) {

    return this.fnpostInputParams(AppSettings.setUserRoleUrl, params);
  }


  getUserRole(params) {

    return this.fnpostInputParams(AppSettings.getUserRoleUrl, params);
  }

  getUserRoleRights(params) {

    return this.fnpostInputParams(AppSettings.getUserRoleRightsUrl, params);
  }



  fnDeleteUserRole(params) {

    return this.fnpostInputParams(AppSettings.deleteUserRoleUrl, params);
  }

  fnCheckUserRole(params) {

    return this.fnpostInputParams(AppSettings.checkUserRoleUrl, params);
  }




  //User
  fnInsertUser(params) {

    return this.fnpostInputParams(AppSettings.insertUserUrl, params);
  }

  fnSetUser(params) {

    return this.fnpostInputParams(AppSettings.setUserUrl, params);
  }


  getUser(params) {

    return this.fnpostInputParams(AppSettings.getUserUrl, params);
  }

  getLoginUser(params) {

    return this.fnpostInputParams(AppSettings.getLoginUserUrl, params);
  }


  fnDeleteUser(params) {

    return this.fnpostInputParams(AppSettings.deleteUserUrl, params);
  }

  fnCheckUser(params) {

    return this.fnpostInputParams(AppSettings.checkUserUrl, params);
  }






  //Asset
  fnInsertAsset(params) {

    return this.fnpostInputParams(AppSettings.insertAssetUrl, params);
  }

  fnSetAsset(params) {

    return this.fnpostInputParams(AppSettings.setAssetUrl, params);
  }


  getAsset(params) {

    return this.fnpostInputParams(AppSettings.getAssetUrl, params);
  }

  getAssetListview(params) {

    return this.fnpostInputParams(AppSettings.getAssetListviewUrl, params);
  }

  getAssetAvailable(params) {

    return this.fnpostInputParams(AppSettings.getAssetAvailableUrl, params);
  }


  fnDeleteAsset(params) {

    return this.fnpostInputParams(AppSettings.deleteAssetUrl, params);
  }

  fnCheckAsset(params) {

    return this.fnpostInputParams(AppSettings.checkAssetUrl, params);
  }




  //Holidays
  fnInsertHolidays(params) {

    return this.fnpostInputParams(AppSettings.insertHolidaysUrl, params);
  }

  fnSetHolidays(params) {

    return this.fnpostInputParams(AppSettings.setHolidaysUrl, params);
  }


  getHolidays(params) {

    return this.fnpostInputParams(AppSettings.getHolidaysUrl, params);
  }

  getHolidaysListview(params) {

    return this.fnpostInputParams(AppSettings.getHolidaysListviewUrl, params);
  }

  fnDeleteHolidays(params) {

    return this.fnpostInputParams(AppSettings.deleteHolidaysUrl, params);
  }

  fnCheckHolidays(params) {

    return this.fnpostInputParams(AppSettings.checkHolidaysUrl, params);
  }




  //Religion
  fnInsertReligion(params) {

    return this.fnpostInputParams(AppSettings.insertReligionUrl, params);
  }

  fnSetReligion(params) {

    return this.fnpostInputParams(AppSettings.setReligionUrl, params);
  }


  getReligion(params) {

    return this.fnpostInputParams(AppSettings.getReligionUrl, params);
  }


  fnDeleteReligion(params) {

    return this.fnpostInputParams(AppSettings.deleteReligionUrl, params);
  }

  fnCheckReligion(params) {

    return this.fnpostInputParams(AppSettings.checkReligionUrl, params);
  }



  //Sponser
  fnInsertSponser(params) {

    return this.fnpostInputParams(AppSettings.insertSponserUrl, params);
  }

  fnSetSponser(params) {

    return this.fnpostInputParams(AppSettings.setSponserUrl, params);
  }


  getSponser(params) {

    return this.fnpostInputParams(AppSettings.getSponserUrl, params);
  }


  fnDeleteSponser(params) {

    return this.fnpostInputParams(AppSettings.deleteSponserUrl, params);
  }

  fnCheckSponser(params) {

    return this.fnpostInputParams(AppSettings.checkSponserUrl, params);
  }



  //ContractType
  fnInsertContractType(params) {

    return this.fnpostInputParams(AppSettings.insertContractTypeUrl, params);
  }

  fnSetContractType(params) {

    return this.fnpostInputParams(AppSettings.setContractTypeUrl, params);
  }


  getContractType(params) {

    return this.fnpostInputParams(AppSettings.getContractTypeUrl, params);
  }


  fnDeleteContractType(params) {

    return this.fnpostInputParams(AppSettings.deleteContractTypeUrl, params);
  }

  fnCheckContractType(params) {

    return this.fnpostInputParams(AppSettings.checkContractTypeUrl, params);
  }




  //Category
  fnInsertCategory(params) {

    return this.fnpostInputParams(AppSettings.insertCategoryUrl, params);
  }

  fnSetCategory(params) {

    return this.fnpostInputParams(AppSettings.setCategoryUrl, params);
  }


  getCategory(params) {

    return this.fnpostInputParams(AppSettings.getCategoryUrl, params);
  }


  fnDeleteCategory(params) {

    return this.fnpostInputParams(AppSettings.deleteCategoryUrl, params);
  }

  fnCheckCategory(params) {

    return this.fnpostInputParams(AppSettings.checkCategoryUrl, params);
  }



  //PayType
  fnInsertPayType(params) {

    return this.fnpostInputParams(AppSettings.insertPayTypeUrl, params);
  }

  fnSetPayType(params) {

    return this.fnpostInputParams(AppSettings.setPayTypeUrl, params);
  }


  getPayType(params) {

    return this.fnpostInputParams(AppSettings.getPayTypeUrl, params);
  }


  fnDeletePayType(params) {

    return this.fnpostInputParams(AppSettings.deletePayTypeUrl, params);
  }

  fnCheckPayType(params) {

    return this.fnpostInputParams(AppSettings.checkPayTypeUrl, params);
  }



  //WpsGroup
  fnInsertWpsGroup(params) {

    return this.fnpostInputParams(AppSettings.insertWpsGroupUrl, params);
  }

  fnSetWpsGroup(params) {

    return this.fnpostInputParams(AppSettings.setWpsGroupUrl, params);
  }


  getWpsGroup(params) {

    return this.fnpostInputParams(AppSettings.getWpsGroupUrl, params);
  }


  fnDeleteWpsGroup(params) {

    return this.fnpostInputParams(AppSettings.deleteWpsGroupUrl, params);
  }

  fnCheckWpsGroup(params) {

    return this.fnpostInputParams(AppSettings.checkWpsGroupUrl, params);
  }



  //Bank
  fnInsertBank(params) {

    return this.fnpostInputParams(AppSettings.insertBankUrl, params);
  }

  fnSetBank(params) {

    return this.fnpostInputParams(AppSettings.setBankUrl, params);
  }


  getBank(params) {

    return this.fnpostInputParams(AppSettings.getBankUrl, params);
  }


  fnDeleteBank(params) {

    return this.fnpostInputParams(AppSettings.deleteBankUrl, params);
  }

  fnCheckBank(params) {

    return this.fnpostInputParams(AppSettings.checkBankUrl, params);
  }



  //Status
  fnInsertStatus(params) {

    return this.fnpostInputParams(AppSettings.insertStatusUrl, params);
  }

  fnSetStatus(params) {

    return this.fnpostInputParams(AppSettings.setStatusUrl, params);
  }


  getStatus(params) {

    return this.fnpostInputParams(AppSettings.getStatusUrl, params);
  }


  fnDeleteStatus(params) {

    return this.fnpostInputParams(AppSettings.deleteStatusUrl, params);
  }

  fnCheckStatus(params) {

    return this.fnpostInputParams(AppSettings.checkStatusUrl, params);
  }



  //LeavePolicy
  fnInsertLeavePolicy(params) {

    return this.fnpostInputParams(AppSettings.insertLeavePolicyUrl, params);
  }

  fnSetLeavePolicy(params) {

    return this.fnpostInputParams(AppSettings.setLeavePolicyUrl, params);
  }


  getLeavePolicy(params) {

    return this.fnpostInputParams(AppSettings.getLeavePolicyUrl, params);
  }


  getLeavePolicyListview(params) {

    return this.fnpostInputParams(AppSettings.getLeavePolicyListviewUrl, params);
  }

  fnDeleteLeavePolicy(params) {

    return this.fnpostInputParams(AppSettings.deleteLeavePolicyUrl, params);
  }

  fnCheckLeavePolicy(params) {

    return this.fnpostInputParams(AppSettings.checkLeavePolicyUrl, params);
  }





  //AccomType
  fnInsertAccomType(params) {

    return this.fnpostInputParams(AppSettings.insertAccomTypeUrl, params);
  }

  fnSetAccomType(params) {

    return this.fnpostInputParams(AppSettings.setAccomTypeUrl, params);
  }


  getAccomType(params) {

    return this.fnpostInputParams(AppSettings.getAccomTypeUrl, params);
  }


  fnDeleteAccomType(params) {

    return this.fnpostInputParams(AppSettings.deleteAccomTypeUrl, params);
  }

  fnCheckAccomType(params) {

    return this.fnpostInputParams(AppSettings.checkAccomTypeUrl, params);
  }



  //HiResource
  fnInsertHiResource(params) {

    return this.fnpostInputParams(AppSettings.insertHiResourceUrl, params);
  }

  fnSetHiResource(params) {

    return this.fnpostInputParams(AppSettings.setHiResourceUrl, params);
  }


  getHiResource(params) {

    return this.fnpostInputParams(AppSettings.getHiResourceUrl, params);
  }


  fnDeleteHiResource(params) {

    return this.fnpostInputParams(AppSettings.deleteHiResourceUrl, params);
  }

  fnCheckHiResource(params) {

    return this.fnpostInputParams(AppSettings.checkHiResourceUrl, params);
  }





  //Salution
  fnInsertSalution(params) {

    return this.fnpostInputParams(AppSettings.insertSalutionUrl, params);
  }

  fnSetSalution(params) {

    return this.fnpostInputParams(AppSettings.setSalutionUrl, params);
  }


  getSalution(params) {

    return this.fnpostInputParams(AppSettings.getSalutionUrl, params);
  }


  fnDeleteSalution(params) {

    return this.fnpostInputParams(AppSettings.deleteSalutionUrl, params);
  }

  fnCheckSalution(params) {

    return this.fnpostInputParams(AppSettings.checkSalutionUrl, params);
  }



  //DocType
  fnInsertDocType(params) {

    return this.fnpostInputParams(AppSettings.insertDocTypeUrl, params);
  }

  fnSetDocType(params) {

    return this.fnpostInputParams(AppSettings.setDocTypeUrl, params);
  }


  getDocType(params) {

    return this.fnpostInputParams(AppSettings.getDocTypeUrl, params);
  }


  fnDeleteDocType(params) {

    return this.fnpostInputParams(AppSettings.deleteDocTypeUrl, params);
  }

  fnCheckDocType(params) {

    return this.fnpostInputParams(AppSettings.checkDocTypeUrl, params);
  }


  //Nationality      
  getNationality(params) {

    return this.fnpostInputParams(AppSettings.getNationalityUrl, params);
  }



  //BloodGroup      
  getBloodGroup(params) {

    return this.fnpostInputParams(AppSettings.getBloodGroupUrl, params);
  }




  //Emp
  fnInsertEmp(params) {

    return this.fnpostInputParams(AppSettings.insertEmpUrl, params);
  }

  fnSetEmp(params) {

    return this.fnpostInputParams(AppSettings.setEmpUrl, params);
  }

  fnSetEmpPop(params) {

    return this.fnpostInputParams(AppSettings.setEmpPopUrl, params);
  }


  getEmp(params) {

    return this.fnpostInputParams(AppSettings.getEmpUrl, params);
  }


  getEmpListView(params) {

    return this.fnpostInputParams(AppSettings.getEmpListViewUrl, params);
  }


  fnDeleteEmp(params) {

    return this.fnpostInputParams(AppSettings.deleteEmpUrl, params);
  }

  fnCheckEmp(params) {

    return this.fnpostInputParams(AppSettings.checkEmpUrl, params);
  }

  getEmpNextPrevious(params) {
    return this.fnpostInputParams(AppSettings.getEmpNextPrevious, params);
  }
  ////ExcelImportEmp
  fnInsertEmpImport(params) {

    return this.fnpostInputParams(AppSettings.insertEmpimportUrl, params);
  }

  //Emp Asset

  fnInsertEmpAsset(params) {

    return this.fnpostInputParams(AppSettings.insertEmpAssetUrl, params);
  }

  fnSetEmpAsset(params) {

    return this.fnpostInputParams(AppSettings.setEmpAssetUrl, params);
  }

  fnSetEmpAssetReturn(params) {

    return this.fnpostInputParams(AppSettings.setEmpAssetReturnUrl, params);
  }

  fnDeleteEmpAsset(params) {

    return this.fnpostInputParams(AppSettings.deleteEmpAssetUrl, params);
  }

  //Emp Pay

  fnInsertEmpPay(params) {

    return this.fnpostInputParams(AppSettings.insertEmpPayUrl, params);
  }

  fnSetEmpPay(params) {

    return this.fnpostInputParams(AppSettings.setEmpPayUrl, params);
  }


  fnDeleteEmpPay(params) {

    return this.fnpostInputParams(AppSettings.deleteEmpPayUrl, params);
  }



  //Emp Skills

  fnInsertEmpSkills(params) {

    return this.fnpostInputParams(AppSettings.insertEmpSkillsUrl, params);
  }

  fnSetEmpSkills(params) {

    return this.fnpostInputParams(AppSettings.setEmpSkillsUrl, params);
  }


  fnDeleteEmpSkills(params) {

    return this.fnpostInputParams(AppSettings.deleteEmpSkillsUrl, params);
  }




  //Expense
  fnInsertExpense(params) {

    return this.fnpostInputParams(AppSettings.insertExpenseUrl, params);
  }

  fnSetExpense(params) {

    return this.fnpostInputParams(AppSettings.setExpenseUrl, params);
  }


  getExpense(params) {

    return this.fnpostInputParams(AppSettings.getExpenseUrl, params);
  }
  getExpenseListview(params) {

    return this.fnpostInputParams(AppSettings.getExpenseListviewUrl, params);
  }

  fnDeleteExpense(params) {

    return this.fnpostInputParams(AppSettings.deleteExpenseUrl, params);
  }




  //Leave
  fnInsertLeave(params) {

    return this.fnpostInputParams(AppSettings.insertLeaveUrl, params);
  }

  fnSetLeave(params) {

    return this.fnpostInputParams(AppSettings.setLeaveUrl, params);
  }


  getLeave(params) {

    return this.fnpostInputParams(AppSettings.getLeaveUrl, params);
  }
  getLeaveListview(params) {

    return this.fnpostInputParams(AppSettings.getLeaveListviewUrl, params);
  }

  fnDeleteLeave(params) {

    return this.fnpostInputParams(AppSettings.deleteLeaveUrl, params);
  }


  checkLeave(params) {

    return this.fnpostInputParams(AppSettings.checkLeaveUrl, params);
  }
  fnSetLeaveOption(params) {

    return this.fnpostInputParams(AppSettings.setLeaveOptionUrl, params);
  }

  fnSetLeaveCancel(params) {

    return this.fnpostInputParams(AppSettings.setLeaveCancelUrl, params);
  }
 


  //Incident
  fnInsertIncident(params) {

    return this.fnpostInputParams(AppSettings.insertIncidentUrl, params);
  }

  fnSetIncident(params) {

    return this.fnpostInputParams(AppSettings.setIncidentUrl, params);
  }


  getIncident(params) {

    return this.fnpostInputParams(AppSettings.getIncidentUrl, params);
  }
  getIncidentListview(params) {

    return this.fnpostInputParams(AppSettings.getIncidentListviewUrl, params);
  }


  fnDeleteIncident(params) {

    return this.fnpostInputParams(AppSettings.deleteIncidentUrl, params);
  }


  //Bonus
  fnInsertBonus(params) {

    return this.fnpostInputParams(AppSettings.insertBonusUrl, params);
  }

  
  fnSetBonus(params) {

    return this.fnpostInputParams(AppSettings.setBonusUrl, params);
  }


  fngetBonus(params) {

    return this.fnpostInputParams(AppSettings.getBonusUrl, params);
  }
  getBonusListview(params) {

    return this.fnpostInputParams(AppSettings.getBonusListviewUrl, params);
  }

  fnDeleteBonus(params) {

    return this.fnpostInputParams(AppSettings.deleteBonusUrl, params);
  }

  fnCheckBonus(params) {

    return this.fnpostInputParams(AppSettings.checkBonusUrl, params);
  }

  fnInsertBonusBulk(params) {

    return this.fnpostInputParams(AppSettings.insertBonusBulkUrl, params);
  }

  //Reimburse
  fnInsertReimburse(params) {

    return this.fnpostInputParams(AppSettings.insertReimburseUrl, params);
  }

  fnSetReimburse(params) {

    return this.fnpostInputParams(AppSettings.setReimburseUrl, params);
  }


  fngetReimburse(params) {

    return this.fnpostInputParams(AppSettings.getReimburseUrl, params);
  }
  getReimburseListview(params) {

    return this.fnpostInputParams(AppSettings.getReimburseListviewUrl, params);
  }

  fnDeleteReimburse(params) {

    return this.fnpostInputParams(AppSettings.deleteReimburseUrl, params);
  }

  
  fnCheckReimburse(params) {

    return this.fnpostInputParams(AppSettings.checkReimburseUrl, params);
  }



  //Memo
  fnInsertMemo(params) {

    return this.fnpostInputParams(AppSettings.insertMemoUrl, params);
  }

  fnSetMemo(params) {

    return this.fnpostInputParams(AppSettings.setMemoUrl, params);
  }


  fngetMemo(params) {

    return this.fnpostInputParams(AppSettings.getMemoUrl, params);
  }
  getMemoListview(params) {

    return this.fnpostInputParams(AppSettings.getMemoListviewUrl, params);
  }

  fnDeleteMemo(params) {

    return this.fnpostInputParams(AppSettings.deleteMemoUrl, params);
  }
  fnGetPriority(params) {

    return this.fnpostInputParams(AppSettings.getPriorityUrl, params);
  }


  //Training
  fnInsertTraining(params) {

    return this.fnpostInputParams(AppSettings.insertTrainingUrl, params);
  }

  fnSetTraining(params) {

    return this.fnpostInputParams(AppSettings.setTrainingUrl, params);
  }


  fngetTraining(params) {

    return this.fnpostInputParams(AppSettings.getTrainingUrl, params);
  }
  getTrainingListview(params) {

    return this.fnpostInputParams(AppSettings.getTrainingListviewUrl, params);
  }

  fnDeleteTraining(params) {

    return this.fnpostInputParams(AppSettings.deleteTrainingUrl, params);
  }




  //Payadv
  fnInsertPayadv(params) {

    return this.fnpostInputParams(AppSettings.insertPayadvUrl, params);
  }

  fnSetPayadv(params) {

    return this.fnpostInputParams(AppSettings.setPayadvUrl, params);
  }


  fngetPayadv(params) {

    return this.fnpostInputParams(AppSettings.getPayadvUrl, params);
  }
  getPayadvListview(params) {

    return this.fnpostInputParams(AppSettings.getPayadvListviewUrl, params);
  }

  fnDeletePayadv(params) {

    return this.fnpostInputParams(AppSettings.deletePayadvUrl, params);
  }
  fnCheckPayadv(params) {

    return this.fnpostInputParams(AppSettings.checkPayadvUrl, params);
  }


  //Transfer
  fnInsertTransfer(params) {

    return this.fnpostInputParams(AppSettings.insertTransferUrl, params);
  }

  fnSetTransfer(params) {

    return this.fnpostInputParams(AppSettings.setTransferUrl, params);
  }


  fngetTransfer(params) {

    return this.fnpostInputParams(AppSettings.getTransferUrl, params);
  }
  getTransferListview(params) {

    return this.fnpostInputParams(AppSettings.getTransferListviewUrl, params);
  }

  fnDeleteTransfer(params) {

    return this.fnpostInputParams(AppSettings.deleteTransferUrl, params);
  }

  fnCheckTransfer(params) {

    return this.fnpostInputParams(AppSettings.checkTransferUrl, params);
  }

  //Overtime
  fnInsertOvertime(params) {

    return this.fnpostInputParams(AppSettings.insertOvertimeUrl, params);
  }

  fnSetOvertime(params) {

    return this.fnpostInputParams(AppSettings.setOvertimeUrl, params);
  }


  fngetOvertime(params) {

    return this.fnpostInputParams(AppSettings.getOvertimeUrl, params);
  }
  getOvertimeListview(params) {

    return this.fnpostInputParams(AppSettings.getOvertimeListviewUrl, params);
  }

  fnDeleteOvertime(params) {

    return this.fnpostInputParams(AppSettings.deleteOvertimeUrl, params);
  }
  ////ExcelImportEmp
  fnInsertOvertimeImport(params) {

    return this.fnpostInputParams(AppSettings.insertOvertimeimportUrl, params);
  }

  //Loan
  fnInsertLoan(params) {

    return this.fnpostInputParams(AppSettings.insertLoanUrl, params);
  }

  fnSetLoan(params) {

    return this.fnpostInputParams(AppSettings.setLoanUrl, params);
  }


  fngetLoan(params) {

    return this.fnpostInputParams(AppSettings.getLoanUrl, params);
  }
  fngetLoanListview(params) {

    return this.fnpostInputParams(AppSettings.getLoanListviewUrl, params);
  }
  fnDeleteLoan(params) {

    return this.fnpostInputParams(AppSettings.deleteLoanUrl, params);
  }


  fnInsertLoanDetails(params) {

    return this.fnpostInputParams(AppSettings.insertLoandetUrl, params);
  }

  fnSetLoanDetails(params) {

    return this.fnpostInputParams(AppSettings.setLoandetUrl, params);
  }


  fnDeleteLoanDetails(params) {

    return this.fnpostInputParams(AppSettings.deleteLoandetUrl, params);
  }
  fnSetLoanPause(params) {

    return this.fnpostInputParams(AppSettings.setLoanPauseUrl, params);
  }


  //PayRoll

  fnCheckPayrollGenerate(params) {
    return this.fnpostInputParams(AppSettings.checkPayrollGenerateUrl, params);
  }

  fngetPayRollPeriod(params) {
    return this.fnpostInputParams(AppSettings.getPayrollPeriodUrl, params);
  }

  fngetPayRollGenerate(params) {
    return this.fnpostInputParams(AppSettings.getPayrollGenerateUrl, params);
  }

  fngetPayRollByPayrollid(params) {
    return this.fnpostInputParams(AppSettings.getPayrollByPayrollidUrl, params);
  }

  fngetPayRollByListview(params) {
    return this.fnpostInputParams(AppSettings.getPayrollByListviewUrl, params);
  }

  fngetPayRollByEmpid(params) {
    return this.fnpostInputParams(AppSettings.getPayrollByEmpidUrl, params);
  }

  fnDeletePayRoll(params) {
    return this.fnpostInputParams(AppSettings.deletePayrollUrl, params);
  }

  fnInsertPayRollLOP(params) {
    return this.fnpostInputParams(AppSettings.insertPayrollLOPUrl, params);
  }

  fnSetPayRollLOP(params) {
    return this.fnpostInputParams(AppSettings.setPayrollLOPUrl, params);
  }

  fnSetPayrollRemoveTransaction(params) {
    return this.fnpostInputParams(AppSettings.setPayrollRemoveTransactionUrl, params);
  }

  fnGetPayrollPeriodDisplay(params) {
    return this.fnpostInputParams(AppSettings.getPayrollPeriodDisplayUrl, params);
  }

  fnGetPayrollWPSFormat(params) {
    return this.fnpostInputParams(AppSettings.getPayrollWPSFormatUrl, params);
  }

  //Document
  fnInsertDocument(params) {

    return this.fnpostInputParams(AppSettings.insertDocumentUrl, params);
  }

  fnSetDocumentv(params) {

    return this.fnpostInputParams(AppSettings.setDocumentUrl, params);
  }

  fnInsertDocumentDetails(params) {

    return this.fnpostInputParams(AppSettings.insertDocumentDetailsUrl, params);
  }

  fngetDocument(params) {

    return this.fnpostInputParams(AppSettings.getDocumentByDocumentidUrl, params);
  }



  fngetDocumentDetails(params) {

    return this.fnpostInputParams(AppSettings.getDocumentDetailsByDocumentDetailsidUrl, params);
  }


  fnDeleteDocument(params) {

    return this.fnpostInputParams(AppSettings.deleteDocumentUrl, params);
  }

  fnDeleteDocumentDetails(params) {

    return this.fnpostInputParams(AppSettings.deleteDocumentDetailsUrl, params);
  }

  //Attachment
  fnInsertAttachment(params) {

    return this.fnpostInputParams(AppSettings.insertAttachmentUrl, params);
  }

  fngetAttachmentDetails(params) {

    return this.fnpostInputParams(AppSettings.getAttachmentByAttachmentidUrl, params);
  }

  fnDeleteAttachmentDetails(params) {

    return this.fnpostInputParams(AppSettings.deleteAttachmentUrl, params);
  }

  fngetAttachmentCountDetails(params) {

    return this.fnpostInputParams(AppSettings.getAttachmentCountByTrxidUrl, params);
  }

  //AnnualLeave
  fnInsertAnnualLeave(params) {

    return this.fnpostInputParams(AppSettings.insertAnnualleaveUrl, params);
  }

  fnSetAnnualLeave(params) {

    return this.fnpostInputParams(AppSettings.setAnnualleaveUrl, params);
  }


  getAnnualLeave(params) {

    return this.fnpostInputParams(AppSettings.getAnnualleaveUrl, params);
  }

  getAnnualleaveListview(params) {

    return this.fnpostInputParams(AppSettings.getAnnualleaveListviewUrl, params);
  }


  fnDeleteAnnualLeave(params) {

    return this.fnpostInputParams(AppSettings.deleteAnnualleaveUrl, params);
  }



  //Leavesalary
  fnInsertLeavesalary(params) {

    return this.fnpostInputParams(AppSettings.insertLeavesalaryUrl, params);
  }

  fnSetLeavesalary(params) {

    return this.fnpostInputParams(AppSettings.setLeavesalaryUrl, params);
  }


  getLeavesalary(params) {

    return this.fnpostInputParams(AppSettings.getLeavesalaryUrl, params);
  }
  getLeavesalaryListview(params) {

    return this.fnpostInputParams(AppSettings.getLeavesalaryListviewUrl, params);
  }

  fnDeleteLeavesalary(params) {

    return this.fnpostInputParams(AppSettings.deleteLeavesalaryUrl, params);
  }
  fnCheckLeavesalary(params) {

    return this.fnpostInputParams(AppSettings.checkLeavesalaryUrl, params);
  }

  //Payadj
  fnInsertPayadj(params) {

    return this.fnpostInputParams(AppSettings.insertPayadjUrl, params);
  }

  fnSetPayadj(params) {

    return this.fnpostInputParams(AppSettings.setPayadjUrl, params);
  }


  getPayadj(params) {

    return this.fnpostInputParams(AppSettings.getPayadjUrl, params);
  }

  getPayadjListview(params) {

    return this.fnpostInputParams(AppSettings.getPayadjListviewUrl, params);
  }

  fnDeletePayadj(params) {

    return this.fnpostInputParams(AppSettings.deletePayadjUrl, params);
  }

  getPayadjdetailsByEmp(params) {

    return this.fnpostInputParams(AppSettings.getPayadjdetailsByEmpUrl, params);
  }

  fnCheckPayadj(params) {

    return this.fnpostInputParams(AppSettings.checkPayadjUrl, params);
  }

  //Approvals
  fnInsertApprovals(params) {

    return this.fnpostInputParams(AppSettings.insertApprovalsUrl, params);
  }

  getApprovalsForms(params) {

    return this.fnpostInputParams(AppSettings.getApprovalsFormsUrl, params);
  }

  getApprovalsListview(params) {

    return this.fnpostInputParams(AppSettings.getApprovalsListviewUrl, params);
  }
  fnSetTranspaymentinfo(params) {

    return this.fnpostInputParams(AppSettings.setTranspaymentinfoUrl, params);
  }
  fnSetRemovePayment(params) {

    return this.fnpostInputParams(AppSettings.setRemovePaymentUrl, params);
  }



  //REPORT
  getReportDetails(params) {
    // if (params.reportname === 'documentexpiry') {
    return this.fnpostInputParams(AppSettings.getDocumentExpiryUrl, params);
    // }
    // else {
    //   return null;
    // }

  }
  getReportEmployeeSummary(params) {

    return this.fnpostInputParams(AppSettings.getReportEmployeeSummaryUrl, params);
  }
  getActivitylogReport(params) {

    return this.fnpostInputParams(AppSettings.getActivitylogReportUrl, params);
  }
  getLeaveReport(params) {

    return this.fnpostInputParams(AppSettings.getLeaveReportUrl, params);
  }
  getAssetReport(params) {

    return this.fnpostInputParams(AppSettings.getAssetReportUrl, params);
  }
  getTrainingReport(params) {

    return this.fnpostInputParams(AppSettings.getTrainingReportUrl, params);
  }
  getOvertimeReport(params) {

    return this.fnpostInputParams(AppSettings.getOvertimeReportUrl, params);
  }
  getPayrollSummaryReport(params) {

    return this.fnpostInputParams(AppSettings.getPayrollSummaryReportUrl, params);
  }
  getEmployeePayReport(params) {

    return this.fnpostInputParams(AppSettings.getEmployeepayReportUrl, params);
  }
  getPayadvReport(params) {

    return this.fnpostInputParams(AppSettings.getPayadvReportUrl, params);
  }
  getEmpSalaryReport(params) {

    return this.fnpostInputParams(AppSettings.getEmpSalaryReportUrl, params);
  }

  getLoanSummaryReport(params) {

    return this.fnpostInputParams(AppSettings.getLoanSummaryReportUrl, params);
  }
  getLoanOutstandingSummaryReport(params) {

    return this.fnpostInputParams(AppSettings.getLoanOutstandingSummaryReportUrl, params);
  }
  getInsuranceReport(params) {

    return this.fnpostInputParams(AppSettings.getInsuranceReportUrl, params);
  }
  getAttendanceReport(params) {

    return this.fnpostInputParams(AppSettings.getAttendanceReportUrl, params);
  }
  getAttendanceSummaryReport(params) {

    return this.fnpostInputParams(AppSettings.getAttendanceSummaryReportUrl, params);
  }
  getEmpRequestdetailsReport(params) {

    return this.fnpostInputParams(AppSettings.getEmpRequestdetailsReportUrl, params);
  }
  getEmpPersonalDetReport(params) {

    return this.fnpostInputParams(AppSettings.getEmpPersonalDetReportUrl, params);
  }
  getHeadCountReport(params) {

    return this.fnpostInputParams(AppSettings.getHeadCountReportUrl, params);
  }
  getFinalsettlementReport(params) {

    return this.fnpostInputParams(AppSettings.getFinalsettlementReportUrl, params);
  }
  getHolidaysReport(params) {

    return this.fnpostInputParams(AppSettings.getHolidaysReportUrl, params);
  }
  getInoutPunchDetailsReport(params) {

    return this.fnpostInputParams(AppSettings.getInoutPunchDetailsReportUrl, params);
  }
  getInoutPunchReport(params) {

    return this.fnpostInputParams(AppSettings.getInoutPunchReportUrl, params);
  }
  getPaymentListviewReport(params) {

    return this.fnpostInputParams(AppSettings.getPaymentListviewReportUrl, params);
  }
  getUserappform(params) {

    return this.fnpostInputParams(AppSettings.getUserappformUrl, params);
  }
  
  //Common
  fnGetIpAddress() {
    // this.http.get('https://jsonip.com')
    //   .subscribe(data => {
    //     this.ipAddress = data.json()

    //   })

  }

  fnInsertActivity(data) {

    var dept_para = {
      logtype: data.logtype,
      logat: data.logat,
      refnum: data.refnum,
      logdescr: data.logdescr,
      logby: data.logby,
      ipaddress: this.ipAddress.ip,
      devicename: this.deviceInfo.browser + " " + this.deviceInfo.os,
    };


    return this.fnpostInputParams(AppSettings.insertactivitylogUrl, dept_para);
  }
  
  getActivitylogTransaction(params) {

    return this.fnpostInputParams(AppSettings.getActivitylogbyTransactionUrl, params);
  }
  //Bankbranch
  fnInsertBankbranch(params) {

    return this.fnpostInputParams(AppSettings.insertBankbranchUrl, params);
  }

  fnSetBankbranch(params) {

    return this.fnpostInputParams(AppSettings.setBankbranchUrl, params);
  }


  getBankbranch(params) {

    return this.fnpostInputParams(AppSettings.getBankbranchUrl, params);
  }


  fnDeleteBankbranch(params) {

    return this.fnpostInputParams(AppSettings.deleteBankbranchUrl, params);
  }

  fnCheckBankbranch(params) {

    return this.fnpostInputParams(AppSettings.checkBankbranchUrl, params);
  }


  //Alerttype
  fnInsertAlerttype(params) {

    return this.fnpostInputParams(AppSettings.insertAlerttypeUrl, params);
  }

  fnSetAlerttype(params) {

    return this.fnpostInputParams(AppSettings.setAlerttypeUrl, params);
  }


  getAlerttype(params) {

    return this.fnpostInputParams(AppSettings.getAlerttypeUrl, params);
  }


  fnDeleteAlerttype(params) {

    return this.fnpostInputParams(AppSettings.deleteAlerttypeUrl, params);
  }

  fnCheckAlerttype(params) {

    return this.fnpostInputParams(AppSettings.checkAlerttypeUrl, params);
  }



  //Settings


  fnSetSettings(params) {

    return this.fnpostInputParams(AppSettings.setSettingsUrl, params);
  }


  getSettings(params) {

    return this.fnpostInputParams(AppSettings.getSettingsUrl, params);
  }



  //Currency
  fnInsertCurrency(params) {

    return this.fnpostInputParams(AppSettings.insertCurrencyUrl, params);
  }

  fnSetCurrency(params) {

    return this.fnpostInputParams(AppSettings.setCurrencyUrl, params);
  }


  getCurrency(params) {

    return this.fnpostInputParams(AppSettings.getCurrencyUrl, params);
  }


  fnDeleteCurrency(params) {

    return this.fnpostInputParams(AppSettings.deleteCurrencyUrl, params);
  }

  fnCheckCurrency(params) {

    return this.fnpostInputParams(AppSettings.checkCurrencyUrl, params);
  }


  //Expensepolicy
  fnInsertExpensepolicy(params) {

    return this.fnpostInputParams(AppSettings.insertExpensepolicyUrl, params);
  }

  fnSetExpensepolicy(params) {

    return this.fnpostInputParams(AppSettings.setExpensepolicyUrl, params);
  }


  getExpensepolicy(params) {

    return this.fnpostInputParams(AppSettings.getExpensepolicyUrl, params);
  }
  getExpensepolicyListview(params) {

    return this.fnpostInputParams(AppSettings.getExpensepolicyListviewUrl, params);
  }

  fnDeleteExpensepolicy(params) {

    return this.fnpostInputParams(AppSettings.deleteExpensepolicyUrl, params);
  }

  fnCheckExpensepolicy(params) {

    return this.fnpostInputParams(AppSettings.checkExpensepolicyUrl, params);
  }



  //Scheduletemplate
  fnInsertScheduletemplate(params) {

    return this.fnpostInputParams(AppSettings.insertScheduletemplateUrl, params);
  }

  fnSetScheduletemplate(params) {

    return this.fnpostInputParams(AppSettings.setScheduletemplateUrl, params);
  }


  getScheduletemplate(params) {

    return this.fnpostInputParams(AppSettings.getScheduletemplateUrl, params);
  }

  fnDeleteScheduletemplate(params) {

    return this.fnpostInputParams(AppSettings.deleteScheduletemplateUrl, params);
  }

  fnCheckScheduletemplate(params) {

    return this.fnpostInputParams(AppSettings.checkScheduletemplateUrl, params);
  }




  //Ptaxmain
  fnInsertPtaxmain(params) {

    return this.fnpostInputParams(AppSettings.insertPtaxmainUrl, params);
  }

  fnSetPtaxmain(params) {

    return this.fnpostInputParams(AppSettings.setPtaxmainUrl, params);
  }


  getPtaxmain(params) {

    return this.fnpostInputParams(AppSettings.getPtaxmainUrl, params);
  }


  getPtaxmainListview(params) {

    return this.fnpostInputParams(AppSettings.getPtaxmainListviewUrl, params);
  }

  fnDeletePtaxmain(params) {

    return this.fnpostInputParams(AppSettings.deletePtaxmainUrl, params);
  }

  fnCheckPtaxmain(params) {

    return this.fnpostInputParams(AppSettings.checkPtaxmainUrl, params);
  }




  //TransPaymode
  fnInsertTransPaymode(params) {

    return this.fnpostInputParams(AppSettings.insertTransPaymodeUrl, params);
  }

  fnSetTransPaymode(params) {

    return this.fnpostInputParams(AppSettings.setTransPaymodeUrl, params);
  }


  getTransPaymode(params) {

    return this.fnpostInputParams(AppSettings.getTransPaymodeUrl, params);
  }


  fnDeleteTransPaymode(params) {

    return this.fnpostInputParams(AppSettings.deleteTransPaymodeUrl, params);
  }

  fnCheckTransPaymode(params) {

    return this.fnpostInputParams(AppSettings.checkTransPaymodeUrl, params);
  }

  
  //FineType
  fnInsertFineType(params) {

    return this.fnpostInputParams(AppSettings.insertFineTypeUrl, params);
  }

  fnSetFineType(params) {

    return this.fnpostInputParams(AppSettings.setFineTypeUrl, params);
  }


  getFineType(params) {

    return this.fnpostInputParams(AppSettings.getFineTypeUrl, params);
  }


  fnDeleteFineType(params) {

    return this.fnpostInputParams(AppSettings.deleteFineTypeUrl, params);
  }

  fnCheckFineType(params) {

    return this.fnpostInputParams(AppSettings.checkFineTypeUrl, params);
  }



  //Fine
  fnInsertFine(params) {

    return this.fnpostInputParams(AppSettings.insertFineUrl, params);
  }

  fnSetFine(params) {

    return this.fnpostInputParams(AppSettings.setFineUrl, params);
  }


  getFine(params) {

    return this.fnpostInputParams(AppSettings.getFineUrl, params);
  }
  getFineListview(params) {

    return this.fnpostInputParams(AppSettings.getFineListviewUrl, params);
  }


  fnDeleteFine(params) {

    return this.fnpostInputParams(AppSettings.deleteFineUrl, params);
  }

  fnCheckFine(params) {

    return this.fnpostInputParams(AppSettings.checkFineUrl, params);
  }



  //Promotion
  fnInsertPromotion(params) {

    return this.fnpostInputParams(AppSettings.insertPromotionUrl, params);
  }

  fnSetPromotion(params) {

    return this.fnpostInputParams(AppSettings.setPromotionUrl, params);
  }


  fngetPromotion(params) {

    return this.fnpostInputParams(AppSettings.getPromotionUrl, params);
  }
  getPromotionListview(params) {

    return this.fnpostInputParams(AppSettings.getPromotionListviewUrl, params);
  }

  fnDeletePromotion(params) {

    return this.fnpostInputParams(AppSettings.deletePromotionUrl, params);
  }


  //RequestType
  fnInsertRequestType(params) {

    return this.fnpostInputParams(AppSettings.insertRequestTypeUrl, params);
  }

  fnSetRequestType(params) {

    return this.fnpostInputParams(AppSettings.setRequestTypeUrl, params);
  }


  getRequestType(params) {

    return this.fnpostInputParams(AppSettings.getRequestTypeUrl, params);
  }


  fnDeleteRequestType(params) {

    return this.fnpostInputParams(AppSettings.deleteRequestTypeUrl, params);
  }

  fnCheckRequestType(params) {

    return this.fnpostInputParams(AppSettings.checkRequestTypeUrl, params);
  }


  //OtherRequest
  fnInsertOtherRequest(params) {

    return this.fnpostInputParams(AppSettings.insertOtherRequestUrl, params);
  }

  fnSetOtherRequest(params) {

    return this.fnpostInputParams(AppSettings.setOtherRequestUrl, params);
  }


  fngetOtherRequest(params) {

    return this.fnpostInputParams(AppSettings.getOtherRequestUrl, params);
  }
  getOtherRequestListview(params) {

    return this.fnpostInputParams(AppSettings.getOtherRequestListviewUrl, params);
  }

  fnDeleteOtherRequest(params) {

    return this.fnpostInputParams(AppSettings.deleteOtherRequestUrl, params);
  }



  //EmpDetailsChange
  fnInsertEmpDetailsChange(params) {

    return this.fnpostInputParams(AppSettings.insertEmpDetailsChangeUrl, params);
  }

  fnSetEmpDetailsChange(params) {

    return this.fnpostInputParams(AppSettings.setEmpDetailsChangeUrl, params);
  }


  fngetEmpDetailsChange(params) {

    return this.fnpostInputParams(AppSettings.getEmpDetailsChangeUrl, params);
  }
  getEmpDetailsChangeListview(params) {

    return this.fnpostInputParams(AppSettings.getEmpDetailsChangeListviewUrl, params);
  }

  fnDeleteEmpDetailsChange(params) {

    return this.fnpostInputParams(AppSettings.deleteEmpDetailsChangeUrl, params);
  }

  fnCheckEmpDetailsChange(params) {

    return this.fnpostInputParams(AppSettings.checkEmpDetailsChangeUrl, params);
  }
  fnInsertEmpDetailsBulkChange(params) {

    return this.fnpostInputParams(AppSettings.insertEmpDetailsChangeBulkUrl, params);
  }

  

  //Short Term Pay
  fnInsertShorttermPay(params) {

    return this.fnpostInputParams(AppSettings.insertShorttermPayUrl, params);
  }
  fnSetShorttermPay(params) {

    return this.fnpostInputParams(AppSettings.setShorttermPayUrl, params);
  }


  getShorttermPay(params) {

    return this.fnpostInputParams(AppSettings.getShorttermPayUrl, params);
  }

  getShorttermPayListview(params) {

    return this.fnpostInputParams(AppSettings.getShorttermPayListviewUrl, params);
  }

  fnDeleteShorttermPay(params) {

    return this.fnpostInputParams(AppSettings.deleteShorttermPayUrl, params);
  }

  fnSetShorttermPaySuspend(params) {

    return this.fnpostInputParams(AppSettings.setShorttermPaySuspendUrl, params);
  }

  fnCheckShorttermPay(params) {

    return this.fnpostInputParams(AppSettings.checkShorttermPayUrl, params);
  }

  //InsuranceType
  fnInsertInsuranceType(params) {

    return this.fnpostInputParams(AppSettings.insertInsuranceTypeUrl, params);
  }

  fnSetInsuranceType(params) {

    return this.fnpostInputParams(AppSettings.setInsuranceTypeUrl, params);
  }


  getInsuranceType(params) {

    return this.fnpostInputParams(AppSettings.getInsuranceTypeUrl, params);
  }


  fnDeleteInsuranceType(params) {

    return this.fnpostInputParams(AppSettings.deleteInsuranceTypeUrl, params);
  }

  fnCheckInsuranceType(params) {

    return this.fnpostInputParams(AppSettings.checkInsuranceTypeUrl, params);
  }

  //InsuranceCompany
  fnInsertInsuranceCompany(params) {

    return this.fnpostInputParams(AppSettings.insertInsuranceCompanyUrl, params);
  }

  fnSetInsuranceCompany(params) {

    return this.fnpostInputParams(AppSettings.setInsuranceCompanyUrl, params);
  }


  getInsuranceCompany(params) {

    return this.fnpostInputParams(AppSettings.getInsuranceCompanyUrl, params);
  }


  fnDeleteInsuranceCompany(params) {

    return this.fnpostInputParams(AppSettings.deleteInsuranceCompanyUrl, params);
  }

  fnCheckInsuranceCompany(params) {

    return this.fnpostInputParams(AppSettings.checkInsuranceCompanyUrl, params);
  }


//Reason
fnInsertReason(params) {

  return this.fnpostInputParams(AppSettings.insertReasonUrl, params);
}

fnSetReason(params) {

  return this.fnpostInputParams(AppSettings.setReasonUrl, params);
}


getReason(params) {

  return this.fnpostInputParams(AppSettings.getReasonUrl, params);
}


fnDeleteReason(params) {

  return this.fnpostInputParams(AppSettings.deleteReasonUrl, params);
}

fnCheckReason(params) {

  return this.fnpostInputParams(AppSettings.checkReasonUrl, params);
}
//Insurance
fnInsertInsurance(params) {

  return this.fnpostInputParams(AppSettings.insertInsuranceUrl, params);
}
fnSetInsurance(params) {

  return this.fnpostInputParams(AppSettings.setInsuranceUrl, params);
}


getInsurance(params) {

  return this.fnpostInputParams(AppSettings.getInsuranceUrl, params);
}

getInsuranceListview(params) {

  return this.fnpostInputParams(AppSettings.getInsuranceListviewUrl, params);
}

fnDeleteInsurance(params) {

  return this.fnpostInputParams(AppSettings.deleteInsuranceUrl, params);
}

fnCheckInsurance(params) {

  return this.fnpostInputParams(AppSettings.checkInsuranceUrl, params);
}

//Airticket
fnInsertAirticket(params) {

  return this.fnpostInputParams(AppSettings.insertAirticketUrl, params);
}
fnSetAirticket(params) {

  return this.fnpostInputParams(AppSettings.setAirticketUrl, params);
}


getAirticket(params) {

  return this.fnpostInputParams(AppSettings.getAirticketUrl, params);
}

getAirticketListview(params) {

  return this.fnpostInputParams(AppSettings.getAirticketListviewUrl, params);
}

fnDeleteAirticket(params) {

  return this.fnpostInputParams(AppSettings.deleteAirticketUrl, params);
}

fnCheckAirticket(params) {

  return this.fnpostInputParams(AppSettings.checkAirticketUrl, params);
}



//FinalSettlement
fnInsertFinalSettlement(params) {

  return this.fnpostInputParams(AppSettings.insertFinalSettlementUrl, params);
}
fnSetFinalSettlement(params) {

  return this.fnpostInputParams(AppSettings.setFinalSettlementUrl, params);
}


getFinalSettlement(params) {

  return this.fnpostInputParams(AppSettings.getFinalSettlementUrl, params);
}

getFinalSettlementListview(params) {

  return this.fnpostInputParams(AppSettings.getFinalSettlementListviewUrl, params);
}

fnDeleteFinalSettlement(params) {

  return this.fnpostInputParams(AppSettings.deleteFinalSettlementUrl, params);
}

fnCheckFinalSettlement(params) {

  return this.fnpostInputParams(AppSettings.checkFinalSettlementUrl, params);
}

//Dashboard

getDashboard(params) {

  return this.fnpostInputParams(AppSettings.getDashboardUrl, params);
}





















}